const DEVICE_ID_KEY = 'hlm_device_id';
const SESSION_ID_KEY = 'hlm_session_id';

function detectBrowserName() {
  const ua = navigator.userAgent;
  if (ua.includes('Edg/')) return 'Edge';
  if (ua.includes('Chrome/')) return 'Chrome';
  if (ua.includes('Firefox/')) return 'Firefox';
  if (ua.includes('Safari/') && !ua.includes('Chrome')) return 'Safari';
  return 'Browser';
}

export function getOrCreateDeviceId() {
  try {
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      id = typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `web-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  } catch {
    return `web-${Date.now()}`;
  }
}

export function buildWebDeviceInfo() {
  const browser = detectBrowserName();
  const platform = navigator.platform || 'unknown';
  return {
    deviceId: getOrCreateDeviceId(),
    deviceName: `${browser} on ${platform}`,
    platform: 'web',
    brand: browser,
    model: platform,
    osVersion: platform,
    appVersion: process.env.REACT_APP_VERSION || 'web',
    userAgent: navigator.userAgent,
  };
}

export function getStoredSessionId() {
  try {
    return localStorage.getItem(SESSION_ID_KEY) || '';
  } catch {
    return '';
  }
}

export function setStoredSessionId(sessionId) {
  try {
    if (sessionId) {
      localStorage.setItem(SESSION_ID_KEY, sessionId);
    } else {
      localStorage.removeItem(SESSION_ID_KEY);
    }
  } catch {
    /* ignore */
  }
}
